import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpLineTurnStation,
  ILineTurnBusStopParser,
} from "../lineInfoRepository.types";
import dayjs from "dayjs";
import { IArrivalTime } from "@/domain/entities/lineInfo/arrivalTime.types";
import { ArrivalTimeOptionCode, ArrivalTimeOptionCodeType } from "@/types";

function parseArrivalTime(
  type: ArrivalTimeOptionCodeType,
  avgTime?: string,
  pastDtm?: string
) {
  if (type === ArrivalTimeOptionCode.PAST) {
    return pastDtm ? dayjs(pastDtm).format("HH:mm") : "-";
  }

  return avgTime?.split(":").slice(0, 2).join(":") ?? "";
}

function parsePrefix(option: ArrivalTimeOptionCodeType, avgTime?: string) {
  // if (option === ArrivalTimeOptionCode.PAST) {
  //   return "";
  // }

  // if (option === ArrivalTimeOptionCode.AVG) {
  //   return avgTime ? "" : "";
  // }

  return "";
}

@injectable()
export class LineTurnBusStopParser implements ILineTurnBusStopParser {
  toDomain(
    data: HttpLineTurnStation,
    type: ArrivalTimeOptionCodeType
  ): Result<IArrivalTime, ParseError> {
    try {
      const lineTurnBusStop: IArrivalTime = {
        type,
        time: parseArrivalTime(type, data.avgArrivalTime, data.pastArrivalDtm),
        prefix: parsePrefix(type, data.avgArrivalTime),
        busStopUid: data.uid,
      };

      return ok(lineTurnBusStop);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
